<template>
  <v-autocomplete
    :label="label"
    :value="value"
    @change="(value) => $emit('change', value)"
    :items="items"
    :disabled="disabled"
    :item-text="itemText"
    :item-value="itemValue"
    :item-disabled="itemDisabled"
    :rules="rules"
    :prepend-inner-icon="prependInnerIcon"
    :persistent-hint="persistentHint"
    :return-object="returnObject"
    :hint="hint"
    :filled="filled"
    :multiple="multiple"
    :chips="chips"
    :deletable-chips="deletableChips"
  >
    <template v-slot:selection="{ item }">
      <slot v-if="hasSelectionSlot" name="selection" :item="item" />
      <span v-else>{{ typeof itemText === 'string' ? getValue(item, itemText) : item.text }}</span>
    </template>
    <template v-slot:item="{ item }">
      <slot v-if="hasItemSlot" name="item" :item="item"/>
      <div v-else-if="item.notification" class="d-flex justify-space-between" style="width: 100%;">
        <div>{{ typeof itemText === 'string' ? getValue(item, itemText) : item.text }}</div>
        <div class="d-flex align-center caption">{{item.notification}} <v-icon small color="grey" class="ml-2" v-if="item.icon">{{ item.icon }}</v-icon></div>         
      </div>
      <span v-else>{{ typeof itemText === 'string' ? getValue(item, itemText) : item.text }}</span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    type: String,
    label: String,
    value: null,
    items: Array,
    disabled: Boolean,
    itemText: [String, Function],
    itemValue: String,
    itemDisabled: String,
    filled: Boolean,
    rules: Array,
    returnObject: Boolean,
    prependInnerIcon: String,
    persistentHint: Boolean,
    hint: String,
    hasSelectionSlot: Boolean,
    hasItemSlot: Boolean,
    multiple: Boolean,
    chips: Boolean,
    deletableChips: Boolean,
  },
  data () {
    return {
      display: null,
    }
  },
  methods: {
    getValue (obj, path) {
      return path.split('.').reduce((o, i) => o[i], obj)
    },
    checkAutoEmit () {
      if (this.items && this.items.length === 1 && !this.items[0].disabled) {
        const value = this.returnObject
          ? this.items[0]
          : this.itemValue
            ? this.getValue(this.items[0], this.itemValue)
            : this.items[0].value
        this.$emit('change', this.multiple ? [value] : value)
      }
    },
  },
  created () {
    this.checkAutoEmit()
  },
  watch: {
    items () {
      this.checkAutoEmit()
    },
  },
}
</script>
